const ths = [
  {
    id: 5,
    label: 'Activity Type',
    intlKey: 'table.activity_type',
    sortable: false
  },
  {
    id: 6,
    label: 'Activity',
    intlKey: 'table.activity',
    sortable: false
  },
  {
    id: 7,
    label: 'Goal',
    intlKey: 'table.goal',
    sortable: false
  },
  {
    id: 8,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
